<template>
  <div class="job-information interview-general-container">
    <div class="rectangle">
      <b-row class="mb-0">
        <b-col>
          <h3 class="job-information__title">
            {{ resource["interviewJobDetails.title"] }}
          </h3>
          <div class="job-information__info">
            <i class="icon-awesome-two" />
            <p class="mb-0">
              {{ resource["interviewJobDetails.info"] }}
            </p>
          </div>
          <b-tooltip
            v-if="
              !generateQuestionWithAiRight || generateQuestionWithAiRight === 0
            "
            target="position-area-tooltip"
            triggers="hover"
            placement="right"
            :delay="{ show: 150, hide: 200 }"
            custom-class="small-tooltip-inner feature-tooltip-general-information"
          >
            {{ resource["upgradePlanTooltip"] }}
          </b-tooltip>
          <div id="position-area-tooltip" class="position-area">
            <validate-form
              v-model="interview.position"
              which-component="multiselect"
              :disabled="
                !generateQuestionWithAiRight ||
                generateQuestionWithAiRight === 0
              "
              allow-empty
              :name="config.position.labelText"
              :label="config.position.label"
              :placeholder="
                resource['interviewDetail.OpenAIPositionPlaceholder']
              "
              :options="config.position.options"
              :loading="config.position.loading"
              :internal-search="config.position.internalSearch"
              :options-limit="config.position.displayedOptionsLimit"
              :limit="config.position.visibleResultLimit"
              :limit-text="config.position.searchLimitText"
              :track-by="config.position.trackBy"
              :show-no-results="showNoResult"
              @search-change="
                (query) => {
                  getPositions(query);
                  searchText = query;
                  page = 0;
                  hasNextPage = true;
                }
              "
            >
              <div slot="customLabel" class="mb-2 custom-label">
                <h3 class="bold">
                  {{
                    isQuestionPage
                      ? resource["questionGenerator.OpenAIPositionTitle"]
                      : resource["interviewDetail.OpenAIPositionTitle"]
                  }}
                </h3>
              </div>
              <div slot="afterList">
                <div
                  v-observe-visibility="reachedEndOfList"
                  v-if="hasNextPage"
                />
              </div>
              <span slot="noResult">{{ resource["label.NoResult"] }}</span>
            </validate-form>

            <div class="ai-job-description">
              <h3>{{ resource["interviewDetail.OpenAIJobDescTitle"] }}</h3>
              <textarea
                class="text-area"
                v-model="interview.jobDescription"
                ref="jobDescriptionTextarea"
                id="jobDescriptionTextarea"
                rows="18"
                maxlength="3000"
                :placeholder="
                  resource['interviewDetail.OpenAIJobDescPlaceholder']
                "
                :disabled="
                  !generateQuestionWithAiRight ||
                  generateQuestionWithAiRight === 0
                "
                @input="adjustHeight"
              >
              </textarea>
            </div>
            <div class="character-limit">
              <span>{{ interview.jobDescription?.length || 0 }}/3000</span>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
import hrvenueService from '../../../services/hrvenue.service';
import { convertObjectKeyValueNames } from '../../../static/helpers';

export default {
  name: 'JobDetailsInformation',
  props: {
    interview: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      page: 0,
      generateQuestionWithAiRight: null,
      showNoResult: false,
      searchText: '',
      hasNextPage: true,
      pageType: '',
      config: {
        position: {
          labelHelpText: 'Position',
          name: 'items',
          label: 'value',
          trackBy: 'id',
          options: [],
          loading: false,
          displayedOptionsLimit: 1000,
          visibleResultLimit: 10,
          minCharLimit: 3,
          internalSearch: false,
          allowSearch: true,
          lastKeywordLength: 0,
        },
      },
    };
  },

  watch: {
    interview: {
      handler(newVal) {
        if (this.generateQuestionWithAiRight > 0 && newVal?.jobDescription) {
          this.interview.jobDescription = newVal?.jobDescription.replace(
            /<[^>]*>?/gm,
            '',
          );
          this.$refs.jobDescriptionTextarea.innerHTML = this.interview.jobDescription;
          //   this.$refs.jobDescriptionTextarea.style.backgroundColor = '#DBF0F9';

          setTimeout(() => {
            this.adjustHeight();
          }, 100);
        }

        if (this.generateQuestionWithAiRight > 0 && !newVal?.jobDescription) {
          this.interview.jobDescription = '';
          this.$refs.jobDescriptionTextarea.innerHTML = '';
          this.$refs.jobDescriptionTextarea.style.backgroundColor = '#FFF';
          setTimeout(() => {
            this.adjustHeight();
          }, 100);
        }
      },
      deep: true,
      immediate: true,
    },
  },

  async created() {
    this.getPositions('');

    await this.getGenerateQuestionWithAiRight();
  },

  computed: {
    isQuestionPage() {
      return this.pageType === 'question';
    },
    isEdit() {
      return !!this.$route.params.interviewId;
    },
  },

  methods: {
    adjustHeight() {
      this.$nextTick(() => {
        const scrollPosition = window.scrollY;
        const textarea = this.$refs.jobDescriptionTextarea;
        if (textarea) {
          textarea.style.height = 'auto';
          textarea.style.height = `${textarea.scrollHeight + 8}px`;
        }
        window.scrollTo(0, scrollPosition);
      });
    },
    async getGenerateQuestionWithAiRight() {
      const response = await hrvenueService.getRight(6);
      this.generateQuestionWithAiRight = response?.totalUsableRight || 0;
    },
    async getPositions(query) {
      this.showNoResult = true;
      this.config.position.loading = true;
      this.config.position.options = [];

      // API REQUEST: Get positions data
      try {
        const request = {
          searchText: query,
          limit: 50,
        };

        const response = await hrvenueService.getJobPositions(request);
        this.config.position.loading = false;

        if (response.items) {
          this.config.position.options = convertObjectKeyValueNames(
            response,
            'items',
            'id',
            'value',
            this.config.position.trackBy,
            this.config.position.label,
          );
          if (!response.hasNextPage) {
            this.hasNextPage = response.hasNextPage;
          }
          if (
            response.items.length === 0
            && request.searchText.length >= this.config.position.minCharLimit
          ) {
            this.config.position.allowSearch = false;
            this.config.position.lastKeywordLength = request.searchText.length;
          } else {
            this.config.position.allowSearch = true;
          }
        }
      } catch (error) {
        //
      } finally {
        this.openAILoading = false;
      }
    },

    reachedEndOfList(reached) {
      if (reached) {
        this.page += 1;
        this.getMorePositions();
      }
    },

    async getMorePositions() {
      this.config.position.loading = true;
      try {
        const request = {
          pageIndex: this.page,
          searchText: this.searchText || '',
          limit: 50,
        };

        const response = await hrvenueService.getJobPositions(request);
        if (response.items) {
          const convertedOptions = convertObjectKeyValueNames(
            response,
            'items',
            'id',
            'value',
            this.config.position.trackBy,
            this.config.position.label,
          );
          this.config.position.options.push(...convertedOptions);
          if (!response.hasNextPage) {
            this.hasNextPage = response.hasNextPage;
          }
          if (
            response.items.length === 0
            && request.searchText.length >= this.config.position.minCharLimit
          ) {
            this.config.position.allowSearch = false;
            this.config.position.lastKeywordLength = request.searchText.length;
          } else {
            this.config.position.allowSearch = true;
          }
        }
      } catch (error) {
        //
      } finally {
        this.config.position.loading = false;
      }
    },
  },
};
</script>
<style lang="scss">
@import "~@/style/starter.scss";

.job-information {
  &__title {
    color: #333333;
    font-family: Roboto;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
  }

  &__info {
    background-color: #fafafa;
    position: relative;
    border-radius: 4px;
    display: flex;
    padding: 8px;
    align-items: flex-start;
    gap: 4px;
    align-self: stretch;
    margin-top: 16px;

    &:before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: linear-gradient(
        to right,
        rgba(255, 241, 232, 1),
        /* #FFF1E8 ile opacity */ rgba(240, 255, 253, 1)
          /* #F0FFFD ile opacity */
      );
      z-index: 1;
      border-radius: 4px;
    }

    p {
      color: #ff8d06 !important;
      font-family: Roboto;
      font-size: 12px !important;
      font-style: normal;
      font-weight: 700 !important;
      line-height: 18px !important;
      z-index: 2;
      margin-bottom: 0 !important;
    }

    i {
      color: #ff8d06 !important;
      font-size: 16px !important;
      z-index: 2;
    }
  }
}

.position-area {
  padding: 16px;
  background: #fafafa;
  border-radius: 4px;
  margin-top: 12px;

  .custom-label {
    display: flex;
    flex-direction: column;
    gap: 8px;

    h3 {
      color: #333333;
      font-family: Roboto;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 20px;
    }
  }

  .multiselect__tags {
    padding-left: 8px !important;
    display: flex;
    align-items: center;
  }

  .multiselect__select:before {
    content: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M7.25488 9.51094L9.41321 11.6693C9.73821 11.9943 10.2632 11.9943 10.5882 11.6693L12.7465 9.51094C13.2715 8.98594 12.8965 8.08594 12.1549 8.08594H7.83821C7.09654 8.08594 6.72988 8.98594 7.25488 9.51094Z" fill="%23333333"/></svg>') !important;
    border: none !important;
    top: 20% !important;
  }

  .multiselect--active {
    .multiselect__tags {
      box-shadow: 0px 0px 0px 4px rgba(255, 141, 6, 0.3) !important;
      outline: 1px solid #ff8d06 !important;
      border-radius: 4px;
    }
  }

  .multiselect__content-wrapper {
    z-index: 999;
    top: 46px !important;
    padding: 4px 0;
    border-radius: 4px !important;
    border: 1px solid #e5e5e5;
    box-shadow: 0px 2px 12px 1px rgba(0, 0, 0, 0.12);
  }

  .ai-job-description {
    width: 100%;

    h3 {
      color: #333333;
      font-family: Roboto;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 20px;
      padding: 8px 0px;
    }

    .text-area {
      width: 100%;
      resize: vertical;
      border: 1px solid #e5e5e5;
      color: #878787;
      font-family: Roboto;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      outline: none;
      padding: 8px;

      &:disabled {
        background-color: #f5f5f5 !important;
        color: #adadad !important;
      }

      &:focus {
        box-shadow: 0px 0px 0px 4px rgba(255, 141, 6, 0.3) !important;
        outline: 1px solid #ff8d06 !important;
      }
    }
  }
  .character-limit {
    display: flex;
    justify-content: flex-end;
    color: #878787;
    font-family: Roboto;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
  }
}
</style>
